import type { EntityStatus, RejectedError } from '@ms/yammer-data-support';

import type { Thread, YammerState } from '../../state/types';
import { getStatus } from '../requestStatuses/selectors';
import { findById as findThread, getStatusForId } from '../threads/selectors';

type GetError = (state: YammerState, id: Thread['id']) => RejectedError;
export const getError: GetError = (state, id) => {
  if (getStatusForId(state, id) === 'rejected') {
    return state.threads.rejected.byId[id];
  }
};

type IsNullOrWasDeleted = (state: YammerState, threadId: Thread['id']) => boolean;
export const isNullOrWasDeleted: IsNullOrWasDeleted = (state, threadId) => {
  const thread = findThread(state, threadId);
  const error = getError(state, threadId);

  const wasDeleted = !!thread && thread.isDeleted;
  const isNull = error instanceof Error ? error.message === 'NullThread' : false;

  return isNull || wasDeleted;
};

type GetLoadNewerRepliesRequestStatus = (state: YammerState, threadId: Thread['id']) => EntityStatus;
export const getLoadNewerRepliesRequestStatus: GetLoadNewerRepliesRequestStatus = (state, threadId) =>
  getStatus(state, 'ThreadLoadNewerReplies', threadId);
